import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

const defaultValue = "";

export class FranchiseNameField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "Test Franchise Name",
      propertyName: "franchiseName",
      uiFieldType: "Input",
      value: defaultValue,
      ...opts,
    });
  }

  get applicable(): boolean {
    const isFranchisee = this._model.lead.franchisee.value === "Yes";
    return isFranchisee;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
